export default __webpack_public_path__ + "static/media/410.d2d6a2a5.png";